import classNames from 'classnames';
import { T } from '~/components/I18n';
import { useLandHistorySummary } from '~/components/Land/History/LandHistory.hooks';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { format } from '~/components/Util/number';
import styles from './LandHistoryReward.module.scss';

export type LandHistoryRewardProps = {
  className?: string;
};
export const LandHistoryReward = ({ className }: LandHistoryRewardProps) => {
  const {
    data: { totalRewardAmountInFnsa },
  } = useLandHistorySummary();

  return (
    <DescriptionList className={classNames(styles.root, className)} layout="inline">
      <dt>
        <T name="citizen_land_myhistory_reward_desc" />
      </dt>
      <dd className={styles.right}>
        {format(totalRewardAmountInFnsa, { zeroAsEmpty: true })} FNSA
      </dd>
    </DescriptionList>
  );
};
